module.exports = __webpack_public_path__ + "fonts/Chivo-Black.33fc3af.woff2";